import { CorrespondenceForm } from '@/components/patient/CorrespondenceForm';
import { GgopForm } from '@/components/ggop/GgopForm';
import type { HospitalReferralPatient } from '@/components/patient/HospitalReferralForm';
import { PatientKorrespondanceTab } from '@/components/patient/PatientKorrespondanceTab';
import type { PatientRecordView } from '@/lib/patientRecordPaths';

export function PatientMedcomWorkspace({
  clinicId,
  patient,
  view,
  revealedCpr,
  onCprRevealed,
  canRevealCpr,
  canWriteGgop,
  canViewReferrals,
  canViewGgop,
  canViewXdis,
  canAttach,
  onCancel,
  onCreated,
  onGgop,
}: {
  clinicId: string;
  patient: HospitalReferralPatient & { first_name: string; last_name: string };
  view: PatientRecordView;
  revealedCpr: string | null;
  onCprRevealed: (cpr: string) => void;
  canRevealCpr: boolean;
  canWriteGgop: boolean;
  canViewReferrals: boolean;
  canViewGgop: boolean;
  canViewXdis: boolean;
  canAttach: boolean;
  onCancel: () => void;
  onCreated: () => void;
  onGgop: () => void;
}) {
  switch (view.kind) {
    case 'correspondence-new':
      return (
        <CorrespondenceForm
          patient={patient}
          revealedCpr={revealedCpr}
          onCprRevealed={onCprRevealed}
          canRevealCpr={canRevealCpr}
          onCancel={onCancel}
          onCreated={onCreated}
        />
      );
    case 'ggop-new':
      return (
        <GgopForm
          patient={patient}
          revealedCpr={revealedCpr}
          onCprRevealed={onCprRevealed}
          canRevealCpr={canRevealCpr}
          onCancel={onCancel}
          onCreated={onCreated}
        />
      );
    case 'tab':
    case 'journal-write':
    case 'henvisning-list':
    case 'henvisning-new':
    case 'henvisning-detail':
      return (
        <PatientKorrespondanceTab
          clinicId={clinicId}
          patientId={patient.id}
          firstName={patient.first_name}
          lastName={patient.last_name}
          hasCpr={patient.has_cpr}
          canRevealCpr={canRevealCpr}
          canWriteGgop={canWriteGgop}
          canViewReferrals={canViewReferrals}
          canViewGgop={canViewGgop}
          canViewXdis={canViewXdis}
          canAttach={canAttach}
          onGgop={onGgop}
        />
      );
    default: {
      const unexpected: never = view;
      return unexpected;
    }
  }
}
